import { useSelector } from 'react-redux'
import { Navigate } from 'react-router'
import { IRootState } from '../../../../redux/types'

const VerifyAccessRoute = ({ visibility }: { visibility: number }) => {
  const { user: authUser } = useSelector((state: IRootState) => state.auth)

  return (
    <>
      {![2, 3].includes(visibility) && authUser === null && !localStorage.getItem('isAuth') && (
        <>
          {/* localStorage.setItem('login_redirect', window.location.pathname + window.location.search)*/}
          <Navigate to="/" replace />
        </>
      )}
    </>
  )
}

export default VerifyAccessRoute
